import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { t } from 'translation'

// import HospitalIcon from '../../assets/icons/hospital.svg'
// import HeartbeatIcon from '../assets/icons/heartbeat.svg'
// import SunIcon from '../assets/icons/sun.svg'
// import PulseIcon from '../assets/icons/pulse.svg'

const IndicationTypeItem2 = ({
  title,
  subtitle,
  img,
  controls,
  key,
  isMobile,
  clickTreatment,
}) => {
  const clickHandler = function (e) {
    const hasControls = e.target
      .closest('.indication_item')
      .querySelector('.indication_controls')
    if (isMobile) {
      clickTreatment()
    } else {
      if (hasControls) {
        const el = e.target.closest('.indication_item')
        const wrap = e.target.closest('.session_type_list')

        if (el.classList.contains('active_mod')) {
          wrap.classList.remove('active_mod')
          el.classList.remove('active_mod')
        } else {
          document.querySelectorAll('.indication_item').forEach((item) => {
            item.classList.remove('active_mod')
          })
          wrap.classList.add('active_mod')
          el.classList.add('active_mod')
        }
      } else {
        clickTreatment()
      }
    }
  }

  return (
    <div className="indication_item" key={key}>
      <div className="indication_item_block">
        {controls && (
          <div className="indication_controls desktop_mod">
            {controls.map(({ Icon, title, clickTreatment }) => (
              <div className="indication_controls_item">
                <button
                  className="indication_controls_btn"
                  onClick={() => clickTreatment()}
                >
                  <div className="indication_controls_icon">
                    <Icon className="icon size_mod" />
                  </div>
                  <div className="indication_controls_title">{title}</div>
                </button>
              </div>
            ))}
          </div>
        )}
        <div className="indication_item_in" onClick={clickHandler}>
          <div className="indication_title">{title}</div>
          <div className="indication_subtitle">{subtitle}</div>
          <div className="indication_img_wrap">
            <img src={img} alt="" className="indication_img" />
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({ auth: { isOnline } }) => ({ isOnline })

export default connect(mapStateToProps)(IndicationTypeItem2)

// IndicationTypeItem2.propTypes = {
//   clickTreatment: PropTypes.func.isRequired,
//   title: PropTypes.string.isRequired,
// }
